import { render, staticRenderFns } from "./products-random.vue?vue&type=template&id=12b24046&scoped=true"
import script from "./products-random.vue?vue&type=script&lang=js"
export * from "./products-random.vue?vue&type=script&lang=js"
import style0 from "./products-random.vue?vue&type=style&index=0&id=12b24046&prod&scoped=true&lang=css"
import style1 from "./products-random.vue?vue&type=style&index=1&id=12b24046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b24046",
  null
  
)

export default component.exports